<template>
  <div class="verification_box">
    <p class="verification_warning">
      请进行银联商务商户入驻签约，签约完成后将自动进入资质审核阶段。协议签署后，将于审核通过之日起生效。
    </p>
    <van-cell-group class="verification_form">
      <van-field
        input-align="right"
        name="contractStatus"
        v-model="contractStatus"
        label="签约状态"
      >
        <template #input>
          <img
            class="sign_icon"
            src="@/assets/img/mobile-img/signing.png"
            alt=""
          />
        </template>
      </van-field>
    </van-cell-group>
    <p class="verification_error">
      <span @click="toSign">前往签约</span>
    </p>
    <div class="verification_btn_box">
      <van-button
        round
        type="info"
        class="verification_btn"
        @click="getContractStatus"
        >刷新</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      contractStatus: "",
    };
  },
  created() {
    this.getContractStatus();
  },
  methods: {
    async getContractStatus() {
      let zwSelfContractType = this.$route.query.type;
      let ums_reg_id = this.$route.query.umsRegId;
      const res = await this.$apis.zzsignServe.applyStatusQuery({
        ums_reg_id,
        zwSelfContractType,
      });
      if (res.resultCode === "200" && res.data.res_code === "0000") {
        const { apply_status } = res.data;
        // 00：签约中--01：签约成功--02：入网审核中--03：入网成功/04：入网失败
        if (apply_status === "00" || apply_status === "01") {
          Toast("已刷新");
        } else if (
          apply_status === "02" ||
          apply_status === "03" ||
          apply_status === "04"
        ) {
          this.$router.replace(
            `/service-sign/sign-result?type=${zwSelfContractType}&umsRegId=${ums_reg_id}`
          );
        }
      } else {
        Toast("系统错误，请稍后重试。");
      }
    },
    async toSign() {
      let zwSelfContractType = this.$route.query.type;
      let ums_reg_id = this.$route.query.umsRegId;
      const res = await this.$apis.zzsignServe.agreementSign({
        ums_reg_id,
        zwSelfContractType,
      });
      if (res.resultCode === "200") {
        if (Object.keys(res.content)) {
          window.open(res.content.url, "_self");
        }
      } else {
        Toast("系统错误，请稍后重试。");
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      console.log(from.path, "path");
      if (from.path === "/service-sign/form-service" || from.path === "/service-sign/public-verification") {
        let data = {
          ums_reg_id: vm.$route.query.umsRegId,
          zwSelfContractType: vm.$route.query.type,
        };
        // 获取签约页面接口
        const response = await vm.$apis.zzsignServe.agreementSign(data);
        if (response.resultCode === "200") {
          if (Object.keys(response.content)) {
            window.open(response.content.url, "_self");
          } else {
            Toast("系统错误，请稍后重试。");
          }
        } else {
          Toast("系统错误，请稍后重试。");
        }
      }
    });
  },
};
</script>

<style scoped lang="scss">
.verification_box {
  background: #f5f5f5;
  min-height: calc(100vh - 44px);
  padding: 15px 12px 0;
  position: relative;
  .verification_warning {
    font-size: 13px;
    color: #333333;
    line-height: 20px;
  }
  .verification_form {
    margin-top: 14px;
    border-radius: 8px;
    overflow: hidden;
    &::v-deep .van-cell {
      padding: 0 12px;
      .van-cell__title {
        color: #333;
        line-height: 48px;
      }
      .van-field__control {
        color: #333;
      }
    }
    .sign_icon {
      margin-top: 7px;
      width: 55px;
      height: 41px;
    }
  }
  .verification_error {
    margin-top: 15px;
    font-size: 13px;
    color: #4a79f1;
    line-height: 19px;
    text-align: center;
  }
  .verification_btn_box {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 6px 15px;
    background-color: #fff;
    width: 100%;
    .verification_btn {
      width: 100%;
      height: 44px;
    }
  }
}
</style>